import React from 'react'
import ArchiveIcon from './archive.svg'
import ArrowBackIcon from './arrow-back.svg'
import ArrowHeadRight from './arrow-head-right.svg'
import ChatIcon from './chat.svg'
import CirclePlusIcon from './circle-plus.svg'
import CircleQuestion from './circle-question.svg'
import Close from './close.svg'
import Comment from './comment.svg'
import DangerIcon from './danger.svg'
import Done from './done.svg'
import NoBoardIcon from './no-board.svg'
import PlusIcon from './plus.svg'
import SettingsIcon from './settings.svg'
import ShevronIcon from './shevron.svg'
import TaskDone from './task-done.svg'
import TaskUndone from './task-undone.svg'
import TickIcon from './tick.svg'
import ToastDefaultIcon from './toast-default-icon.svg'
import ToastErrorIcon from './toast-error-icon.svg'
import ToastSuccessIcon from './toast-success-icon.svg'
import ToastWarningIcon from './toast-warning-icon.svg'
import Undone from './undone.svg'

export {
  ArchiveIcon,
  PlusIcon,
  CirclePlusIcon,
  TickIcon,
  ShevronIcon,
  NoBoardIcon,
  ArrowBackIcon,
  ChatIcon,
  SettingsIcon,
  CircleQuestion,
  DangerIcon,
  ArrowHeadRight,
  Close,
  Comment,
  ToastSuccessIcon,
  ToastWarningIcon,
  ToastErrorIcon,
  ToastDefaultIcon
}

interface Props extends React.SVGProps<SVGElement> {
  done: boolean
}

export const DoneIcon = ({done, ...rest}: Props) =>
  done ? <Done {...rest} /> : <Undone {...rest} />

export const TaskDoneIcon = ({done, ...rest}: Props) =>
  done ? <TaskDone {...rest} /> : <TaskUndone {...rest} />
